import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import { useEffect, useState } from "react";
import "./CenterModal.scss";
import { ModalSize } from "./enum/CenterModalEnum";
import { Iconify } from "@repo/design-system/components/ui";

const stack = [];
const modalStack = {
    push: (handler) => stack.push(handler),
    pop: () => stack.pop(),
    isTop: (handler) => stack[stack.length - 1] === handler,
};

export const CenterModal = ({
    isApprovalValidate, isOpen, handleToggleModal, noHeader,
    children, className, modalTitle, headerClassName = "",
    modelSizeClass = ModalSize.WD50, footerChildren,
    ...props
}) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (isOpen) {
            modalStack.push(handleToggleModal);
        }
        const handleEsc = (event) => {
            if (event.key === "Escape") {
                if (modalStack.isTop(handleToggleModal)) {
                    event.stopPropagation();
                    handleToggleModal();
                }
            }
        };
        if (isOpen) {
            document.addEventListener("keydown", handleEsc);
        }
        return () => {
            document.removeEventListener("keydown", handleEsc);
            if (modalStack.isTop(handleToggleModal)) {
                modalStack.pop();
            }
        };
    }, [isOpen, handleToggleModal]);


    useEffect(() => {
        if (isOpen) {
            setTimeout(() => setVisible(true), 10);
        } else {
            setVisible(false);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className={`modal fade ${visible ? "show" : ""} ${props.modalClassName || ""}`}
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            tabIndex="-1">
            <div className={`modal-dialog modal-dialog-centered ${modelSizeClass} ${visible ? "animate-in" : ""}`}
                onClick={(e) => e.stopPropagation()}>
                <div className="modal-content">
                    {!noHeader && (
                        <div className="modal-header">
                            <h5 className={`modal-title ${headerClassName}`}>
                                {modalTitle}
                            </h5>
                            <Iconify icon="iconamoon:close-bold" width={25} targetId="close"
                                className="cursor-pointer btn-close-icon"
                                ttLabel="Close" onClick={handleToggleModal} />
                        </div>
                    )}
                    <div className={`modal-body ${className || ""}`}>
                        {children}
                    </div>
                    {footerChildren &&
                        <div className={`modal-footer ${props.modalFooterClassName || ""}`}>
                            {footerChildren}
                        </div>
                    }
                </div>
            </div>
        </div>,
        document.body
    );
};

CenterModal.propTypes = {
    isApprovalValidate: PropTypes.bool,
    isOpen: PropTypes.bool.isRequired,
    handleToggleModal: PropTypes.func.isRequired,
    noHeader: PropTypes.bool,
    children: PropTypes.node.isRequired,
    modelSizeClass: PropTypes.string,
    modalTitle: PropTypes.string
};